/**
 * @desc 月度盘点-创建月度盘点
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.amazonInventoryMonthly.createAmazonInventoryMonthly.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/fulfilment/amazonInventoryMonthly/createAmazonInventoryMonthly`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
